var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 3C2.5 2.73478 2.60536 2.48043 2.79289 2.29289C2.98043 2.10536 3.23478 2 3.5 2H5.653C5.88971 2.00011 6.1187 2.08418 6.29924 2.23726C6.47979 2.39034 6.60018 2.6025 6.639 2.836L7.379 7.271C7.41436 7.48222 7.38097 7.69921 7.28376 7.89003C7.18655 8.08085 7.03065 8.23543 6.839 8.331L5.291 9.104C5.84611 10.4797 6.67283 11.7293 7.72178 12.7782C8.77072 13.8272 10.0203 14.6539 11.396 15.209L12.17 13.661C12.2655 13.4695 12.4199 13.3138 12.6106 13.2166C12.8012 13.1194 13.0179 13.0859 13.229 13.121L17.664 13.861C17.8975 13.8998 18.1097 14.0202 18.2627 14.2008C18.4158 14.3813 18.4999 14.6103 18.5 14.847V17C18.5 17.2652 18.3946 17.5196 18.2071 17.7071C18.0196 17.8946 17.7652 18 17.5 18H15.5C8.32 18 2.5 12.18 2.5 5V3Z",
    fill: "#B5B8C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.1b1dc3cd77bab58309561daa511d1cb0.svg";
export { ForwardRef as ReactComponent };